/**
 * Action message - bot-side metadata that may not be user-visible. The
 * legacy renderer rendered nothing for the visible message body and
 * instead let the action handler kick off a side-effect (e.g. open a
 * URL, redirect to checkout). We keep the same contract: render an
 * optional text body if the message includes one, otherwise an empty
 * shell that LayoutManager can detect and skip.
 */
export function ActionMessage({ message }) {
  if (!message.text) return null
  return (
    <p
      className="ometrics-msg-action m-0 text-sm italic text-[var(--color-muted-foreground)]"
      dangerouslySetInnerHTML={{ __html: message.text }}
    />
  )
}
